import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'role',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  emptyMessage: "You don't have contents, visit the content section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      helpText: 'Name of the role.',
    },
  ],
};
